import React from 'react'
import { color } from 'stylist'
import { withRouter } from 'react-router-dom'
import styled from 'react-emotion'
import ConfirmationModal from 'components/Editor/ConfirmationModal'
import Nav from './Nav'
import Title from './Title'
import URLSearchParams from 'url-search-params'

const params = new URLSearchParams(window.location.search)
export const hideHeader = params.get('header') === 'off'

const HeaderContainer = styled.div`
  height: 112px;
  padding-top: 20px;
  padding-bottom: 15px;

  background: ${color('ink')};
  border-width: 0 0 5px 0;
`

const HeaderBodyContainer = styled.div`
  width: 920px;
  margin-left: auto;
  margin-right: auto;
  color: ${color('silver')};
`

const TopRow = styled.div`
  width: 100%;
  margin-bottom: 11px;
`

const BottomRow = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
`

const HeaderBody = ({ saveSurvey }) => (
  <HeaderBodyContainer>
    <TopRow>
      <Nav />
    </TopRow>
    <BottomRow>
      <Title />
      <ConfirmationModal saveSurvey={saveSurvey} />
    </BottomRow>
  </HeaderBodyContainer>
)

const Header = ({ saveSurvey }) => {
  return (
    <HeaderContainer>
      <HeaderBody saveSurvey={saveSurvey} />
    </HeaderContainer>
  )
}

export default withRouter(Header)



// WEBPACK FOOTER //
// ./src/components/Editor/Header/index.js